import { Outlet, useLocation } from 'react-router';
import { useTrackActivity } from '@/hooks/useTrackActivity';
import { ErrorBoundary } from './ErrorBoundary';
import { Footer } from './Footer';
import { SiteHeader } from './NavBar/SiteHeader';

/**
 * Layout wrapper for all public-facing pages.
 *
 * Also where partner activity is recorded: every page a partner can reach sits
 * under this layout, so a new route is tracked by existing. Nothing is written
 * for our own admins — see `useTrackActivity`.
 */
export function PublicLayout() {
  useTrackActivity();
  const location = useLocation();

  return (
    <div className='tw:flex tw:min-h-screen tw:flex-col tw:bg-ed-cream'>
      <SiteHeader />
      <main className='tw:flex-1'>
        {/* Inside the layout rather than around it, so a page that fails still
            leaves the header and footer to navigate and to contact us from.
            Keyed on the path: a boundary latches once it has caught, and without
            the key a client who did navigate away would carry the error page
            with them. */}
        <ErrorBoundary key={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
      <Footer />
    </div>
  );
}
